import { Component, HostListener, Inject, OnDestroy, OnInit } from '@angular/core';
import { faReceipt, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { PartyInvoice } from '@unleashed/models/booking';
import { InvoiceApiService } from '@unleashed/api/booking';
import { BRAND_OPTIONS, BrandOptions } from '@unleashed/common/config';
import { Observable, of, Subject } from 'rxjs';
import { AuthorizationService } from '@unleashed/services/account';
import { BookingSessionService } from '@unleashed/services/booking';
import { catchError, finalize, takeUntil, tap } from 'rxjs/operators';
import { BusyService } from '@unleashed/services/common';

@Component({
  selector: 'ua-reservations',
  templateUrl: './reservations.component.html',
  styleUrls: ['./reservations.component.scss']
})
export class ReservationsComponent implements OnInit, OnDestroy {

  faReceipt = faReceipt;
  faMapMarkerAlt = faMapMarkerAlt;
  partiesByPark$?: Observable<Map<string, PartyInvoice[]>>;
  viewWidth: number;
  brandId: number;
  destroy$ = new Subject<boolean>();
  errorCode?: number;

  @HostListener('window:resize', ['$event'])
  onResize(event?: any): void {
    this.viewWidth = window.screen.width;
  }
  constructor(
    private bookingInvoiceApiService: InvoiceApiService,
    private authService: AuthorizationService,
    private sessionService: BookingSessionService,
    private busyService: BusyService,
    @Inject(BRAND_OPTIONS) private brandOptions: BrandOptions
  ) {
    this.viewWidth = (window.screen.width);
    this.brandId = brandOptions.brandId;
  }

  ngOnInit(): void {
    this.busyService.set('reservations', true);
    this.partiesByPark$ = this.bookingInvoiceApiService.getInvoicesForAccount(this.brandId)
      .pipe(
        catchError(() => {
          this.errorCode = 500;
          return of(undefined as unknown as Map<string, PartyInvoice[]>);
        }),
        finalize(() => this.busyService.set('reservations', false))
      );

    this.authService.getUser()
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe(user => {
        if (!user.loggedIn) {
          this.sessionService.navigateToLogin();
        }
      });

    this.sessionService.removeBooking();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

}
